<shared-core-loading-page
  [loadingProgress]="completeOcrRequestsCount / ctBatchStoreService.ctBatchPageCount" />

<div class="bg-secondary flex h-full flex-col gap-y-4 antialiased">
  @if (doneLoading) {
    <ct-shared-header [ctBatch]="ctBatchStoreService.ctBatch" />
    <div class="flex h-full min-h-0 flex-col gap-y-4 px-4">
      <div class="h-full min-h-0">
        <!-- Change component on step in extraction process -->
        <ct-extraction-app-view-page />
      </div>
    </div>
    <ct-extraction-footer />
  }
</div>
